function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { DatePicker } from '../date';
import { MULTI_CHOICE_FILTER_CONTROL_MIN_WIDTH } from './MultiChoiceFilter';
export default function DateFilter(_ref) {
  let {
    initialValue = '',
    onFilter,
    ...props
  } = _ref;
  const [value, setValue] = useState(initialValue);
  const {
    t
  } = useTranslation();
  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);
  return /*#__PURE__*/React.createElement("div", _extends({}, props, {
    onClick: e => {
      e.preventDefault();
      e.stopPropagation();
    },
    style: {
      ...props.style,
      minWidth: MULTI_CHOICE_FILTER_CONTROL_MIN_WIDTH
    }
  }), /*#__PURE__*/React.createElement(DatePicker, {
    popperProps: {
      strategy: 'fixed'
    },
    selected: value,
    onChange: e => {
      setValue(e);
      onFilter(e);
    }
  }));
}